<div class="container-fluid p-0">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="mb-0 text-dark fw-bold">Sharing Center</h3>
    <button class="btn btn-outline-primary btn-sm" (click)="ngOnInit()">
      <i class="bi bi-arrow-clockwise"></i> Refresh
    </button>
  </div>

  <!-- Quick Stats -->
  <div class="row g-3 mb-4">
    <div class="col-md-4">
      <div class="card stat-card h-100 p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="stat-label">Active Planograms</div>
            <div class="stat-value">{{ totalActivePlanograms }}</div>
          </div>
          <i class="bi bi-grid-3x3-gap text-primary fs-1 opacity-25"></i>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card stat-card warning h-100 p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="stat-label">Pending Feedback</div>
            <div class="stat-value">{{ totalPendingFeedback }}</div>
          </div>
          <i class="bi bi-chat-dots text-warning fs-1 opacity-25"></i>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card stat-card success h-100 p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="stat-label">Unique Viewers</div>
            <div class="stat-value">{{ distinctViewers }}</div>
          </div>
          <i class="bi bi-people text-success fs-1 opacity-25"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-3 h-100">
    <!-- Planogram Summaries (9/12) -->
    <div class="col-lg-9 d-flex flex-column">
      <div class="card h-100">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0 text-secondary">Shared Planograms</h5>
          <div class="input-group w-auto">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search planograms..."
              [(ngModel)]="searchTerm"
              (input)="onSearch(searchTerm)"
            />
            <button class="btn btn-outline-secondary btn-sm" (click)="loadPlanogramSummaries()">
              <i class="bi bi-search"></i>
            </button>
          </div>
        </div>

        <div class="card-body p-0">
          <div *ngIf="loadingSummaries" class="p-5 text-center text-muted">
            <div class="spinner-border text-primary mb-2"></div>
            <p>Loading summaries...</p>
          </div>

          <div class="table-responsive" *ngIf="!loadingSummaries">
            <table class="table table-hover align-middle mb-0">
               <thead class="bg-light text-muted small text-uppercase">
                <tr>
                  <th class="ps-4 cursor-pointer" (click)="toggleSort('store')">
                    Store <i class="bi" [ngClass]="getSortIcon('store')"></i>
                  </th>
                  <th class="cursor-pointer" (click)="toggleSort('merch')">
                    Merch <i class="bi" [ngClass]="getSortIcon('merch')"></i>
                  </th>
                  <th class="cursor-pointer" (click)="toggleSort('save')">
                    Latest Save <i class="bi" [ngClass]="getSortIcon('save')"></i>
                  </th>
                  <th class="text-center">Shared With</th>
                  <th class="text-center cursor-pointer" (click)="toggleSort('viewed')">
                    Viewed <i class="bi" [ngClass]="getSortIcon('viewed')"></i>
                  </th>
                  <th class="text-center cursor-pointer" (click)="toggleSort('feedback')">
                    Feedback <i class="bi" [ngClass]="getSortIcon('feedback')"></i>
                  </th>
                  <th class="text-center cursor-pointer" (click)="toggleSort('completed')">
                    Completed <i class="bi" [ngClass]="getSortIcon('completed')"></i>
                  </th>
                  <th class="text-center cursor-pointer" (click)="toggleSort('approved')">
                    Approved <i class="bi" [ngClass]="getSortIcon('approved')"></i>
                  </th>
                  <th class="cursor-pointer" (click)="toggleSort('activity')">
                    Last Activity <i class="bi" [ngClass]="getSortIcon('activity')"></i>
                  </th>
                  <th class="text-end pe-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of planogramSummaries">
                  <td class="ps-4 fw-bold text-primary">{{ p.storeName }}</td>
                  <td class="small">{{ p.merchName }}</td>
                  <td class="small text-muted">{{ p.latestSaveName || '—' }}</td>
                  <td class="text-center"><span class="badge bg-light text-dark border">{{ p.totalSharedUsers }}</span></td>
                  <td class="text-center"><span class="badge bg-light text-dark border">{{ p.viewedUsers }}</span></td>
                  <td class="text-center">
                    <span class="badge" [ngClass]="p.feedbackUsers > 0 ? 'bg-warning text-dark' : 'bg-light text-muted border'">
                      {{ p.feedbackUsers }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="badge" [ngClass]="p.feedbackCompleted > 0 ? 'bg-warning text-dark' : 'bg-light text-muted border'">
                      {{ p.feedbackCompleted }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="badge" [ngClass]="p.feedbackApproved > 0 ? 'bg-warning text-dark' : 'bg-light text-muted border'">
                      {{ p.feedbackApproved }}
                    </span>
                  </td>
                  <td class="small text-muted">
                    {{ p.lastActivity ? (p.lastActivity | date : 'MMM d, h:mm a') : '—' }}
                  </td>
                  <td class="text-end pe-4">
                    <div class="btn-group">
                      <button (click)="viewPlanogram(p.planogramId)" class="btn btn-sm btn-primary" title="Open">
                        <i class="bi bi-eye-fill"></i>
                      </button>
                      <button (click)="openPlanogramActivity(p.planogramId)" class="btn btn-sm btn-outline-secondary" title="Activity">
                        <i class="bi bi-activity"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="planogramSummaries.length === 0 && !loadingSummaries">
                  <td colspan="6" class="text-center p-5">
                    <div class="text-muted opacity-50 mb-3">
                      <i class="bi bi-folder2-open fs-1"></i>
                    </div>
                    <h6 class="text-secondary">No planograms found</h6>
                    <p class="small text-muted" *ngIf="searchTerm">
                      No results match "{{searchTerm}}". Try a different keyword.
                    </p>
                    <p class="small text-muted" *ngIf="!searchTerm">
                      You haven't shared any planograms yet.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-footer bg-white" *ngIf="!loadingSummaries && planogramSummaries.length">
          <div class="pagination-controls">
            <button
              class="btn btn-sm btn-outline-secondary"
              (click)="changePlanogramPage(currentPlanogramPage - 1)"
              [disabled]="currentPlanogramPage === 1"
            >
              Previous
            </button>
            <span class="mx-3 small text-muted">Page {{ currentPlanogramPage }} of {{ totalPlanogramPages }}</span>
            <button
              class="btn btn-sm btn-outline-secondary"
              (click)="changePlanogramPage(currentPlanogramPage + 1)"
              [disabled]="currentPlanogramPage === totalPlanogramPages"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Activity (3/12) -->
    <div class="col-lg-3 d-flex flex-column">
      <div class="card h-100">
        <div class="card-header">
          <h5 class="mb-0 text-secondary">Recent Activity</h5>
        </div>
        <div class="card-body overflow-auto" style="max-height: 70vh;">
          <div *ngIf="loadingEvents" class="text-center text-muted py-4">
            <div class="spinner-border spinner-border-sm mb-2"></div>
          </div>

          <div class="timeline mt-2" *ngIf="!loadingEvents && recentEvents.length">
            <div class="timeline-item" *ngFor="let e of recentEvents">
              <span class="timeline-date">{{ e.dateCreated | date : 'MMM d, h:mm a' }}</span>
              <div class="timeline-content">
                <strong>{{ e.user.name }} {{ e.user.surname }}</strong><br />
                <span class="badge bg-light text-secondary border">{{ e.eventName }}</span>
                <p class="small" *ngIf="e.planogramName">in <span class="text-primary">{{ e.planogramName }}</span></p>
                <p class="fst-italic mt-1" *ngIf="e.description && e.description !== e.eventName">"{{ e.description }}"</p>
              </div>
            </div>
          </div>

          <div *ngIf="!loadingEvents && recentEvents.length === 0" class="text-center text-muted small">
            No recent activity recorded.
          </div>
        </div>

        <div class="card-footer bg-white text-center" *ngIf="!loadingEvents && recentEvents.length">
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-secondary" (click)="changeEventsPage(currentEventsPage - 1)" [disabled]="currentEventsPage === 1">
              <i class="bi bi-chevron-left"></i>
            </button>
            <button class="btn btn-outline-secondary" disabled>{{ currentEventsPage }}</button>
            <button
              class="btn btn-outline-secondary"
              (click)="changeEventsPage(currentEventsPage + 1)"
              [disabled]="currentEventsPage === totalEventsPages"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>